import { Validators } from '@angular/forms';

import { NoteDetailFormValue } from '../../coaching-note/note-detail-form-value.model';
import {
    CmpsFormField,
    CmpsFormFields,
} from '../../coaching-observation/experimental.form';
import { TranslationKeyMap } from '../coaching-commitment.i18n';

export interface CloseFormFields extends CmpsFormFields {
    REASON: CmpsFormField;
    COMMENT: CmpsFormField;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CloseFormFields: CloseFormFields = {
    REASON: {
        name: 'reason',
        label: '',
        placeholder: TranslationKeyMap._9519_SELECT_DISPOSITION_REASON,
        validators: [Validators.required],
        validationMsgs: {
            required:
                TranslationKeyMap._9517_PLEASE_SELECT_DISPOSITION_REASON_BEFORE_PROCEEDING,
        },
    },
    COMMENT: {
        name: 'comment',
        label: '',
    },
};

export interface CloseFormValue {
    reason?: number;
    comment?: NoteDetailFormValue;
}
